import { useCallback, useState } from 'react';
import { SurveyHttp } from '@/services';
import { parseError } from '@/utils';

export default function useSurvey() {

  const [surveys, setSurveys] = useState<SurveyEntity[]>([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string>();

  const fetchSurvey = useCallback(async () => {
    try {
      setError(null);
      setLoading(true);
      const data = await SurveyHttp.fetchUserSurveys();
      const surveys = data;
      if ((!surveys || Object.keys(surveys).length === 0)) {
        return setSurveys(null);
      }
      setSurveys(surveys);
    }
    catch (e) {
      setError(parseError(e));
    }
    finally {
      setLoading(false);
    }
  }, []);

  return { surveys, fetchSurvey, error, loading };
}
